var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinAltFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3764 38.8341C30.8204 37.7235 44.3332 31.0603 44.3332 19.5C44.3332 11.1237 37.0205 4.33334 27.9998 4.33334C18.9792 4.33334 11.6665 11.1237 11.6665 19.5C11.6665 31.0603 25.1793 37.7235 27.6233 38.8341C27.8656 38.9442 28.1341 38.9442 28.3764 38.8341ZM27.9998 26C31.8658 26 34.9998 23.0899 34.9998 19.5C34.9998 15.9102 31.8658 13 27.9998 13C24.1338 13 20.9998 15.9102 20.9998 19.5C20.9998 23.0899 24.1338 26 27.9998 26Z",
    fill: "#174240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1449 35.75C43.5785 36.7381 44.3332 37.859 44.3332 39C44.3332 40.141 43.5785 41.2619 42.1449 42.25C40.7114 43.2381 38.6495 44.0587 36.1665 44.6292C33.6835 45.1997 30.8669 45.5 27.9998 45.5C25.1327 45.5 22.3162 45.1997 19.8332 44.6292C17.3502 44.0587 15.2883 43.2381 13.8548 42.25C12.4212 41.2619 11.6665 40.141 11.6665 39C11.6665 37.859 12.4212 36.7381 13.8548 35.75",
    stroke: "#174240",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAltFill);
export default __webpack_public_path__ + "static/media/pin-alt-fill.0261d983b406200fb43ce0eeb0da02f9.svg";
export { ForwardRef as ReactComponent };